export default __webpack_public_path__ + "static/media/handsonmobile.da500273.jpg";